import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-brand-black py-24 px-4" data-id="element-86">
      <div className="max-w-4xl mx-auto text-center" data-id="element-87">
        {/* Headline */}
        <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-88">
          Take Back Control of Your Hairline
        </h2>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-89">
          Join 75,000+ men who chose the modern, science-backed solution to hair
          loss. No drugs. No surgery. Just results.
        </p>

        {/* CTA Button */}
        <a href="https://offer.crowncontrol.shop/" className="inline-flex items-center gap-3 bg-brand-red text-white px-12 py-6 rounded-lg font-bold text-2xl hover:bg-red-700 transition-colors shadow-2xl group" aria-label="Get CrownControl" data-id="element-90">
          Learn More
          <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-91" />
        </a>

        {/* Trust Indicators */}
        <div className="mt-12 pt-12 border-t border-gray-700" data-id="element-92">
          <div className="flex flex-wrap items-center justify-center gap-8 text-gray-400" data-id="element-93">
            <div className="flex items-center gap-2" data-id="element-94">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-95">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-96" />
              </svg>
              <span data-id="element-97">180-Day Guarantee</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-98">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-99">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-100" />
              </svg>
              <span data-id="element-101">Free Shipping</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-102">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-103">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-104" />
              </svg>
              <span data-id="element-105">Secure Checkout</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}